module.exports = __webpack_public_path__ + "img/google.2302c2fb.png";